/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeCatalogListComputeOffers } from "../../funcs/computeCatalogListComputeOffers.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListComputeOffersRequest$inboundSchema,
};

export const tool$computeCatalogListComputeOffers: ToolDefinition<typeof args> =
  {
    name: "compute-catalog-list-compute-offers",
    description: `List provider offers

Cluster administrators may always read this route. Organization administrators may read it only when provider anonymity is disabled.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeCatalogListComputeOffers(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
